import React from 'react';
import { observer } from 'mobx-react';
import { classes } from '~utils/ClassNames';
import { Shade, ShadeSizeWrapper, Size } from '../CartItemDescriptionStyles';
import { toHexCode } from '~utils/ToHexCode';
import TextLabel from '~views/Shared/TextLabel/TextLabel';

interface IShadeSize {
    shadeCode: string;
    shade: string;
    size: string;
    readonly?: boolean;
}

const descriptionName = 'cart-item-description';
const shadeSizeClass = classes(`${descriptionName}-product-wrapper`);
const sizeClass = classes(`${descriptionName}-product-wrapper-size`);
const shadeClass = classes(`${descriptionName}-product-wrapper-shade`);

export const ShadeSize = observer((props: IShadeSize) => {
    const { shadeCode, shade, size, readonly } = props;
    const shadeHex = toHexCode(shadeCode);

    if (!shade && !size) {
        return null;
    }

    return (
        <ShadeSizeWrapper className={shadeSizeClass}>
            {shade && (
                <Shade
                    readonly={readonly}
                    shadeCode={shadeHex}
                    className={shadeClass}
                    data-testid="cart-item-description-product-wrapper-shade"
                >
                    {shade}
                </Shade>
            )}
            {size && size !== 'null' && (
                <Size
                    className={sizeClass}
                    data-testid="cart-item-description-product-wrapper-size"
                >
                    <TextLabel text={`${size}`} />
                </Size>
            )}
        </ShadeSizeWrapper>
    );
});
